import { render, staticRenderFns } from "./ProductGroupNew.vue?vue&type=template&id=3359889e&scoped=true&"
import script from "./ProductGroupNew.vue?vue&type=script&lang=ts&"
export * from "./ProductGroupNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3359889e",
  null
  
)

export default component.exports